import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2830c56e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2830c56e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830c56e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2830c56e')) {
      api.createRecord('2830c56e', component.options)
    } else {
      api.reload('2830c56e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2830c56e&scoped=true", function () {
      api.rerender('2830c56e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/billing/deliveryNote/index.vue"
export default component.exports